<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <b>{{ isEditMode ? 'Blog Yazısını Düzenle' : 'Yeni Blog Yazısı' }}</b>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="blogForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Genel Bilgiler -->
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0">Genel Bilgiler</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Dil *</label>
                <select class="form-control" formControlName="languageId">
                  <option value="">Dil Seçin</option>
                  <option *ngFor="let lang of languages" [value]="lang.id">
                    {{ lang.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Kategori *</label>
                <select class="form-control" formControlName="blogCategoryId">
                  <option value="">Kategori Seçin</option>
                  <option *ngFor="let cat of categories" [value]="cat.id">
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Slug (URL) *</label>
                <input type="text" class="form-control" formControlName="slug" placeholder="ornek-blog-yazisi">
                <small class="text-muted">URL'de görünecek kısa isim</small>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Etiketler</label>
                <input type="text" class="form-control" formControlName="tags" placeholder="etiket1, etiket2, etiket3">
                <small class="text-muted">Virgülle ayırın</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Başlık *</label>
                <input type="text" class="form-control" formControlName="title">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Özet *</label>
                <textarea class="form-control" rows="3" formControlName="summary"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>İçerik *</label>
                <quill-editor formControlName="content" [modules]="editorModules" [styles]="{height: '300px'}"></quill-editor>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Öne Çıkan Görsel</label>
                <div *ngIf="featuredImageUrl" class="mb-2">
                  <img [src]="featuredImageUrl" class="img-thumbnail" style="max-width: 300px;">
                </div>
                <ngx-dropzone [accept]="'image/*'" (change)="onFileSelect($event)" [multiple]="false">
                  <ngx-dropzone-label>
                    <div class="dz-default dz-message">
                      <span>Görsel yüklemek için tıklayın veya sürükleyin</span>
                    </div>
                  </ngx-dropzone-label>
                  <ngx-dropzone-image-preview *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onFileRemove()">
                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                  </ngx-dropzone-image-preview>
                </ngx-dropzone>
              </div>
            </div>
          </div>

          <!-- SEO Bilgileri -->
          <div class="card bg-light mt-3">
            <div class="card-header">
              <h6 class="mb-0">SEO Bilgileri</h6>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label>Meta Title</label>
                <input type="text" class="form-control" formControlName="metaTitle">
              </div>

              <div class="form-group">
                <label>Meta Description</label>
                <textarea class="form-control" rows="2" formControlName="metaDescription"></textarea>
              </div>

              <div class="form-group">
                <label>Meta Keywords</label>
                <input type="text" class="form-control" formControlName="metaKeywords">
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="isPublished" formControlName="isPublished">
                  <label class="custom-control-label" for="isPublished">Yayında</label>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="isFeatured" formControlName="isFeatured">
                  <label class="custom-control-label" for="isFeatured">Öne Çıkan</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="submitted">
        <i class="fa fa-spinner fa-spin" *ngIf="submitted"></i>
        {{ isEditMode ? 'Güncelle' : 'Kaydet' }}
      </button>
    </div>
  </form>
</div>
